import type { StructuredCollectionConfig } from '@ltvco/refresh-lib/hooks';

/**
 * Collections used by the Marriage Index Records.
 *
 * IMPORTANT:
 * - The order of this list must match the order defined in Remoulade.
 * - Do not reorder existing collections, as the position is used to maintain
 *   consistency with Remoulade mappings and processing logic.
 * - When adding a new collection, append it to the end of the array.
 * - Existing entries should remain in their current positions.
 */
export const MARRIAGE_INDEX_COLLECTIONS: StructuredCollectionConfig[] = [
  {
    id: '0000033',
    plainName: 'Nebraska Marriage Index, 1956-2019',
    type: 'marriage_index',
    source: 'marriageIndexSearch',
    reportType: 'marriage_indexes',
    ga4ReportType: 'ne_marriage_index',
    state: 'NE',
    yearStart: 1956,
    yearEnd: 2019,
    options: { combineFirstMiddleName: true },
    events: [
      {
        name: 'Marriage',
        isRange: false,
      },
    ],
  },
  {
    id: '0000038',
    plainName: 'Kentucky Marriage Index, 1973-1999',
    type: 'marriage_index',
    source: 'marriageIndexSearch',
    reportType: 'marriage_indexes',
    ga4ReportType: 'ky_marriage_index',
    state: 'KY',
    yearStart: 1973,
    yearEnd: 1999,
    events: [
      {
        name: 'Marriage',
        isRange: false,
      },
    ],
  },
  {
    id: '0000068',
    plainName: 'Tennessee Marriage Index, 1980-2014',
    type: 'marriage_index',
    source: 'marriageIndexSearch',
    reportType: 'marriage_indexes',
    ga4ReportType: 'tn_marriage_index',
    state: 'TN',
    yearStart: 1980,
    yearEnd: 2014,
    events: [
      {
        name: 'Marriage',
        isRange: false,
      },
    ],
  },
  {
    id: '0000170',
    plainName: 'Indiana, Marriage Index, 1958-2022',
    type: 'marriage_index',
    source: 'marriageIndexSearch',
    reportType: 'marriage_indexes',
    ga4ReportType: 'in_marriage_index',
    state: 'IN',
    yearStart: 1958,
    yearEnd: 2022,
    events: [
      {
        name: 'Marriage',
        isRange: false,
      },
    ],
  },
  {
    id: '0000147',
    plainName: 'Minnesota Marriage Index, 1850-2022',
    type: 'marriage_index',
    source: 'marriageIndexSearch',
    reportType: 'marriage_indexes',
    ga4ReportType: 'mn_marriage_index',
    state: 'MN',
    yearStart: 1850,
    yearEnd: 2022,
    options: { combineFirstMiddleName: true },
    events: [
      {
        name: 'Marriage',
        isRange: false,
      },
    ],
  },
  {
    id: '0000107',
    plainName: 'Nevada, Clark County (Las Vegas), Marriage Licenses, 1905-2024',
    type: 'marriage_index',
    source: 'marriageIndexSearch',
    reportType: 'marriage_indexes',
    ga4ReportType: 'nv_marriage_index',
    state: 'NV',
    yearStart: 1905,
    yearEnd: 2024,
    options: { combineFirstMiddleName: true },
    isV2: true,
    events: [
      {
        name: 'Marriage',
        isRange: false,
      },
    ],
  },
  {
    id: '0000013',
    plainName: 'New York, New York City, Marriage Index, 1950-1995',
    type: 'marriage_index',
    source: 'marriageIndexSearch',
    reportType: 'marriage_indexes',
    ga4ReportType: 'ny_marriage_index',
    state: 'NY',
    yearStart: 1950,
    yearEnd: 1995,
    isV2: true,
    events: [
      {
        name: 'Marriage',
        isRange: false,
      },
    ],
  },
  {
    id: '0000028',
    plainName: 'Massachusetts, Marriage Index, 1841-1910',
    type: 'marriage_index',
    source: 'marriageIndexSearch',
    reportType: 'marriage_indexes',
    ga4ReportType: 'ma_marriage_index',
    state: 'MA',
    yearStart: 1841,
    yearEnd: 1910,
    options: { combineFirstMiddleName: true },
    isV2: true,
    events: [
      {
        name: 'Marriage',
        isRange: false,
      },
    ],
  },
  {
    id: '0000019',
    plainName: 'Connecticut, Marriage Index, 1897-2001',
    source: 'marriageIndexSearch',
    type: 'marriage_index',
    reportType: 'marriage_indexes',
    ga4ReportType: 'ct_marriage_index',
    state: 'CT',
    yearStart: 1897,
    yearEnd: 2001,
    options: { combineFirstMiddleName: true },
    isV2: true,
    events: [
      {
        name: 'Marriage',
        isRange: false,
      },
    ],
  },
  {
    id: '0000007',
    plainName: 'Texas, Marriage Index, 1966-2014',
    source: 'marriageIndexSearch',
    type: 'marriage_index',
    reportType: 'marriage_indexes',
    ga4ReportType: 'tx_marriage_index',
    state: 'TX',
    yearStart: 1966,
    yearEnd: 2014,
    isV2: true,
    events: [
      {
        name: 'Marriage',
        isRange: false,
      },
    ],
  },
];
